// before afer slider
if(typeof a1BeforeAfterSlider === 'undefined') {
    const SesoBeforeAfterSlider = class {

        constructor(selector) {
            this.el = {};
            this.el.container = selector instanceof HTMLElement
                ? selector
                : (
                    document.getElementById(selector) ||
                    document.querySelector(selector)
                );

            this.el.imageBefore = this.el.container.querySelector('.img-before')
                ? this.el.container.querySelector('.img-before')
                : undefined;

            this.el.imageAfter = this.el.container.querySelector('.img-after')
                ? this.el.container.querySelector('.img-after')
                : undefined;

            this.el.titleBefore = this.el.container.closest('.slider').querySelector('.slide-title-before')
                ? this.el.container.closest('.slider').querySelector('.slide-title-before')
                : undefined;

            this.el.titleAfter = this.el.container.closest('.slider').querySelector('.slide-title-after')
                ? this.el.container.closest('.slider').querySelector('.slide-title-after')
                : undefined;

            this.el.slideBefore = undefined;
            this.el.slideAfter = undefined;
            this.el.dragHandler = undefined;

            this.params = {
                classInitialized: 'is-initialized',
                classSlide: 'slide',
                classSlideBefore: 'slide-before',
                classSlideAfter: 'slide-after',
                classTitleBefore: 'slide-title-before',
                classDragHandler: 'drag-handler',
                dragStart: false
            };

            if (typeof this.el.imageBefore !== 'undefined' && typeof this.el.imageAfter !== 'undefined') {
                this.initSlider();
            }
        }

        initSlider () {
            if (!this.el.container.classList.contains(this.params.classInitialized)) {
                // create markup wrapper
                // slide before
                this.el.slideBefore = document.createElement('div');
                this.el.slideBefore.classList.add(this.params.classSlide, this.params.classSlideBefore);
                if(typeof this.el.titleBefore !== 'undefined') {
                    this.el.slideBefore.innerHTML = this.el.imageBefore.outerHTML + this.el.titleBefore.outerHTML;
                    this.el.titleBefore.remove();
                } else {
                    this.el.slideBefore.innerHTML = this.el.imageBefore.outerHTML;
                }
                // slide after
                this.el.slideAfter = document.createElement('div');
                this.el.slideAfter.classList.add(this.params.classSlide, this.params.classSlideAfter);
                if(typeof this.el.titleAfter !== 'undefined') {
                    this.el.slideAfter.innerHTML = this.el.imageAfter.outerHTML + this.el.titleAfter.outerHTML;
                    this.el.titleAfter.remove();
                } else {
                    this.el.slideAfter.innerHTML = this.el.imageAfter.outerHTML;
                }
                this.el.imageBefore.outerHTML = this.el.slideBefore.outerHTML;
                this.el.imageAfter.outerHTML = this.el.slideAfter.outerHTML;

                // create drag handler
                this.el.dragHandler = document.createElement('div');
                this.el.dragHandler.classList.add(this.params.classDragHandler);
                this.el.dragHandler.draggable = true;
                this.el.container.innerHTML += this.el.dragHandler.outerHTML;

                // slider is initialized
                this.el.container.classList.add(this.params.classInitialized);

                this.bindEvents();
            }
        }

        bindEvents () {
            let that = this;

            'mousedown touchstart'.split(' ').forEach(function(evt) {
                that.el.container.querySelector('.' + that.params.classDragHandler).addEventListener(evt, function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    that.markDragStart();
                });
            });

            'mouseup touchend'.split(' ').forEach(function (evt) {
                document.addEventListener(evt, function () {
                    that.markDragStop();
                });
            });

            'mousemove touchmove'.split(' ').forEach(function (evt) {
                that.el.container.addEventListener(evt, function (event) {
                    if(that.isDragStart()) {
                        var moveX = evt === 'touchmove' ? event.changedTouches[0].clientX : event.clientX;
                        that.updateSlider(moveX);
                    }
                });
            });
        }

        markDragStart () {
            this.params.dragStart = true;
        }

        markDragStop () {
            this.params.dragStart = false;
        }

        isDragStart () {
            return this.params.dragStart === true;
        }

        updateSlider (moveX) {
            // get position offset, updated drag handler and slide before
            var position = this.getPositionOffset(moveX);
            this.updateDragHandler(position);
            this.updateSlideBefore(position);
        }

        getPositionOffset (offsetX) {
            var containerWidth = this.el.container.offsetWidth;
            var containerOffset = this.el.container.getBoundingClientRect().left;
            var prePosition = (offsetX - containerOffset) * 100 / containerWidth;
            var position = null;

            if (prePosition < 0) {
                // start reached
                position = 0;
            } else if (prePosition > 100) {
                // end reached
                position = 100;
            } else {
                // in the middle - cursor position
                position = prePosition;
            }

            return position;
        }

        updateDragHandler (position) {
            this.el.container.querySelector('.' + this.params.classDragHandler).style.left = position + '%';
        }

        updateSlideBefore (position) {
            var translateValue = 100 - position;
            this.el.container.querySelector('.' + this.params.classSlideBefore).style.transform = 'translate(' + (-1 * translateValue) + '%)';
            this.el.container.querySelector('.' + this.params.classSlideBefore + ' picture').style.transform = 'translate(' + translateValue + '%)';
            this.el.container.querySelector('.' + this.params.classSlideBefore + ' img').style.transform = 'translate(' + translateValue + '%)';
            this.el.container.querySelector('.' + this.params.classTitleBefore).style.left = translateValue + '%';
        }
    }

    if (typeof window !== 'undefined') {
        window.a1BeforeAfterSlider = SesoBeforeAfterSlider;
    }

    window.addEventListener('load', () => {
        // slider before after
        document.querySelectorAll('a1-fragment[name="slider-before-after"]').forEach(function (fragment) {
            window.a1BeforeAfterSlider = new SesoBeforeAfterSlider(fragment.querySelector('.animator'));
        });
    });
}
